import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
	selector: 'cp-visit-selection-item',
	templateUrl: './visit.selection.item.template.html',
	styleUrls: ['./visit.selection.item.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitSelectionItemComponent  {
	@Input() visit : any;
}
